<template>
<el-table :data="tableData" style="width: 100%" :show-header="false" @row-click="newToken">
    <el-table-column>
        <template slot-scope="scope">
            <div class="d-flex justify-content-start align-items-center">
                <NameInitials :name="scope.row.name" small />
                <h5 class="c-ndarkfour bold break-name mb-0">
                    {{ scope.row.cnpj.companyType == 2 ? scope.row.name : scope.row.tradingName | formatName }}
                </h5>
                <caption v-if="scope.row.cnpj.companyType != 2" class="ml-3 mb-0">
                    {{ scope.row.cnpj.cnpj | formatCnpjOrCpf }}
                </caption>
                <caption class="ml-3 mb-0">
                    {{ scope.row.cnpj.companyType == 0 ? 'Financiador' :  scope.row.cnpj.companyType == 1 ? 'Fornecedor' :  scope.row.cnpj.companyType == 2 ? 'Comprador':  'Acesso ao backoffice' }}
                </caption>
                <div v-if="$store.state.user.userAdm" class="d-flex">
                    <caption class="ml-3 mb-0 c-ndarkfour bgc-nlightone partner" v-for="partner in scope.row.partners" :key="partner">
                        {{ getPartners[partner] || 'Cashforce' }}
                    </caption>
                </div>
            </div>
        </template>
    </el-table-column>
    <el-table-column width="300px">
        <template slot-scope="scope">
            <div class="d-flex justify-content-end align-items-center">
                <Button class="button-details button-details-loading" size="small" @click="newToken(scope.row)" :color="getPrimaryColor">
                    <!-- <img src="../../assets/imgs/icons/loading.svg" alt="loading" /> -->
                    <Loading :color="getPrimaryColorHex.one"/>
                    <span>Acessar</span>
                </Button>
            </div>
        </template>
    </el-table-column>
</el-table>
</template>

<script>
import NameInitials from '@/components/icons/NameInitials'
import selectCompany from '@/api/selectCompany'
import jwt_decode from "jwt-decode";
import Loading from '../../assets/imgs/icons/Loading.vue';
export default {
    components: {
    NameInitials,
    Loading
},
    props: {
        tableData: {
            required: true,
        }
    },
    methods: {
        async newToken(row) {
            const { cnpj, companyType } = row.cnpj
            let result = await selectCompany(cnpj, companyType)
            if (result.data.ok) {
                const {
                    userAdm
                } = jwt_decode(result.data.payload);
                // this.this.loadingButton = false
                if (companyType == 0 || userAdm) window.location.href = `${this.getServiceUrls.MARKETPLACE}/opportunities`
                if (companyType == 1) window.location.href = `${this.getServiceUrls.MARKETPLACE}/home`
                if (companyType == 2) window.location.href = `${this.getServiceUrls.MARKETPLACE}/order/receivables`
                if (companyType == 3) window.location.href = `${this.getServiceUrls.MARKETPLACE}/order`
            }
        }
    }
}
</script>

<style scoped>
.partner {
    padding: 4px 8px;
    border-radius: 26px;
}
</style>
